import { array, mixed, object, string } from "yup";
import { useEffect, useState } from "react";

import Validations from "@helpers/validations";
import { defaultValues } from "../misc/constants";
import size from "lodash/size";
import useAxios from "@hooks/use-axios";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

const useUpsertEmail = (props) => {
    const { getAllEmails, activeEmail } = props;
    const { axiosInstance, loading } = useAxios({ base: "panel" });
    const [isOpen, setIsOpen] = useState(false);
    const [attachments, setAttachments] = useState([]);

    const { requiredValidation } = Validations();

    const methods = useForm({
        defaultValues,
        resolver: yupResolver(
            object({
                subject    : string(),
                to         : requiredValidation({ name: "To" }),
                cc         : array().of(mixed()),
                bcc        : array().of(mixed()),
                attachments: array().of(mixed()),
                body       : requiredValidation({ name: "Body" })
            })
        )
    });

    const { handleSubmit, reset, setValue } = methods;

    const toggleModal = () => {
        setIsOpen((prev) => !prev);
        reset(defaultValues);
        setAttachments([]);
    };

    const handleFileUpload = (e) => {
        setAttachments((prev) => [...prev, ...e]);
    };

    const removeUploadedFile = (attachment) => {
        setAttachments((prev) => {
            return prev.filter((ele) => ele.name !== attachment.name);
        });
    };

    const onSubmit = async (isReply = false) => {
        handleSubmit(async (formData) => {
            const payload = new FormData();
            const areCCAttached = size(formData.cc);
            const areBCCAttached = size(formData.bcc);
           
            payload.append("to", formData.to);
            payload.append("body", formData.body);
            attachments.map((attachment) => {
                payload.append("files", attachment);
            });

            if (isReply) {
                payload.append("subject", `Re: ${activeEmail.subject}`);
            } else {
                payload.append("subject", formData.subject);
                if (areCCAttached) {
                    payload.append(
                        "cc",
                        size(formData.cc) > 1 ? formData.cc.join(",") : formData.cc[0]
                    );
                }
                if (areBCCAttached) {
                    payload.append(
                        "bcc",
                        size(formData.cc) > 1 ? formData.cc.join(",") : formData.bcc[0]
                    );
                }
            }
            await axiosInstance.post("/gmail/send", payload);
            getAllEmails();
            reset({ ...defaultValues });
            setAttachments([]);
        })();
    };

    useEffect(() => {
        setValue("attachments", attachments);
    }, [attachments]);

    return {
        axiosInstance,
        loading,
        toggleModal,
        isOpen,
        methods,
        onSubmit,
        handleFileUpload,
        removeUploadedFile,
        attachments
    };
};

export default useUpsertEmail;